import Vue from "vue";
//@ts-ignore
import * as VueGoogleMaps from 'vue2-google-maps';
import http from "./helper/http-common";
import { store } from './store';
import bus from "./helper/eventBus";
import VueTheMask from "vue-the-mask";
import InsuranceModal from "./components/InsuranceModal.vue";
import CvModal from "./components/CvModal.vue";
import RealEstateCalculator from "./components/RealEstateCalculator.vue";
import RealEstateModal from "./components/RealEstateModal.vue";
import MortageSubjectModal from "./components/MortageSubjectModal.vue";
import VoluntaryMedicalInsurance from "./components/VoluntaryMedicalInsurance.vue";
import TravelInsurance from "./components/TravelInsurance.vue";
import CascoInsuranceCalculator from "./components/CascoInsuranceCalculator.vue";
import CascoInsurance from "./components/CascoInsurance.vue";
import GreenCard from "./components/GreenCard.vue";
import GeneralLiabilityInsurance from "./components/GeneralLiabilityInsurance.vue";
import DisciplinedDriver from "./components/DisciplinedDriver.vue";
import CarInsurance from "./components/CarInsurance.vue";
import OnlineCarInsurance from "./components/OnlineCarInsurance.vue";
import DisciplinedDriverCalculator from "./components/DisciplinedDriverCalculator.vue";
import CooperativeCascoCalculator from "./components/CooperativeCascoCalculator.vue";
import VoluntaryRealEstate from "./components/VoluntaryRealEstate.vue";
import InsuranceCenturyCalculator from "./components/InsuranceCenturyCalculator.vue";
import CarefulCascoCalculator from "./components/CarefulCascoCalculator.vue";
import PropertyLiabilityCalculator from "./components/PropertyLiabilityCalculator.vue";
import Accident from "./components/Accident.vue";
import Map from "./components/Map.vue";
import CustomSelect from "./components/CustomSelect.vue";
//@ts-ignore
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Popup from "./components/Popup.vue";
import AllCalculator from "./components/AllCalculator.vue";
import CascoCarInsurance from "./components/CascoCarInsurance.vue";
import IncidentForm from "./components/IncidentForm.vue";
import TravelEvent from "./components/TravelEvent.vue";
import PropertyIncident from "./components/PropertyIncident.vue";
import Inputs from "./components/Inputs.vue";
import PhoneInput from "./components/PhoneInput.vue";
import Feedback from "./components/Feedback.vue";
import AppealsModal from "./components/AppealsModal.vue";
import TravelInsuranceVerification from "./components/TravelInsuranceVerification.vue";
Vue.config.devtools = true;
export var EXTERNAL_API_TOKEN = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwaS1teS5xYWxhLmF6L2FwaS92MS9nZXQtand0LWZvci8yNTg5IiwiaWF0IjoxNzY5Mjg2ODM5LCJleHAiOjE3NzcwNjI4MzksIm5iZiI6MTc2OTI4NjgzOSwianRpIjoiWDdieThNWWpHQ2dtMVpTVSIsInN1YiI6IjI1ODkiLCJwcnYiOiIyM2JkNWM4OTQ5ZjYwMGFkYjM5ZTcwMWM0MDA4NzJkYjdhNTk3NmY3In0.eZuutbaA5-KpORMP8McPgKjO_e1JmCk_XxTNiN94ZGQ"; // Placeholder for the token
Vue.use(VueTheMask);
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyCU2PByeCmzC92ukFqFNV-t3EMFjZD_BBs",
        // libraries: 'places',
    }
});
Vue.prototype.$http = http;
Vue.prototype.$bus = bus;
// Vue.prototype.$formatDateLocal = formatDateLocal;
Vue.component('cv-modal', CvModal);
Vue.component('insurance-modal', InsuranceModal);
Vue.component('car-insurance', CarInsurance);
Vue.component('real-estate-calculator', RealEstateCalculator);
Vue.component('real-estate-modal', RealEstateModal);
Vue.component('mortage-subject-modal', MortageSubjectModal);
Vue.component('general-liability-insurance', GeneralLiabilityInsurance);
Vue.component('voluntary-medical-insurance', VoluntaryMedicalInsurance);
Vue.component('travel-insurance-modal', TravelInsurance);
Vue.component('casco-insurance-calculator', CascoInsuranceCalculator);
Vue.component('casco-insurance-modal', CascoInsurance);
Vue.component('green-card', GreenCard);
Vue.component('disciplined-driver', DisciplinedDriver);
Vue.component('disciplined-driver-calculator', DisciplinedDriverCalculator);
Vue.component('online-car-insurance', OnlineCarInsurance);
Vue.component('cooperative-casco-calc', CooperativeCascoCalculator);
Vue.component('voluntary-real-estate', VoluntaryRealEstate);
Vue.component('insurance-century-calc', InsuranceCenturyCalculator);
Vue.component('careful-casco-calc', CarefulCascoCalculator);
Vue.component('property-liability-calc', PropertyLiabilityCalculator);
Vue.component('accident', Accident);
Vue.component('custom-select', CustomSelect);
Vue.component('date-picker', DatePicker);
Vue.component('popup', Popup);
Vue.component('all-calculator', AllCalculator);
Vue.component('casco-car-insurance', CascoCarInsurance);
Vue.component('incident-form', IncidentForm);
Vue.component('travel-event', TravelEvent);
Vue.component('property-event', PropertyIncident);
Vue.component('inputs', Inputs);
Vue.component('phone-input', PhoneInput);
Vue.component('feedback', Feedback);
Vue.component('appeals-modal', AppealsModal);
Vue.component('mapPopup', Map);
Vue.component('travel-insurance-verification', TravelInsuranceVerification);
if (document.getElementById("vue-layout")) {
    new Vue({
        store: store,
        el: "#vue-layout",
    });
}
if (document.getElementById("vue-layout2")) {
    new Vue({
        store: store,
        el: "#vue-layout2",
    });
}
// store.dispatch('translation/initLocales').then(() => {
//     store.commit('translation/setLocale', window.language);
//
// });
